import { Link } from "react-router-dom";
import { useCmsMenu } from "@/hooks/useCms";

const HeaderCmsMenu = () => {
  const { data: items = [] } = useCmsMenu("header");
  if (items.length === 0) return null;
  return (
    <nav className="border-t" style={{ borderColor: "hsl(174 90% 50% / 0.1)" }}>
      <div className="max-w-[1100px] mx-auto px-4 py-2 flex items-center justify-center gap-x-5 gap-y-1 flex-wrap">
        {items.map((it, i) => {
          const isExternal = it.url.startsWith("http");
          const cls = "text-xs sm:text-sm font-medium text-muted-foreground hover:text-primary transition-colors";
          return isExternal ? (
            <a key={i} href={it.url} target="_blank" rel="noopener noreferrer" className={cls}>{it.label}</a>
          ) : (
            <Link key={i} to={it.url} className={cls}>{it.label}</Link>
          );
        })}
      </div>
    </nav>
  );
};

export default HeaderCmsMenu;
